/* eslint-disable no-lonely-if */
/* eslint-disable no-else-return */
/* eslint-disable no-unreachable */
/* eslint-disable import/no-unresolved */
import moment from "moment";
import regex from "src/helpers/regex";
import * as yup from "yup";

// const checkDates = (secondDate: string, firstDate: any) => {
//   const d1 = new Date(firstDate);
//   const d2 = new Date(secondDate);

//   if (d1 < d2) {
//     return true;
//   }
//   return false;
// };

// const checkDates = (exitDate: string, entryDate: any) => {
//   if (!entryDate || !exitDate) return false;

//   const isValidDate = (date: string) => moment(date, "DD/MM/YYYY").isValid();
//   const [entryDay, entryMonth, entryYear] = entryDate.split("/");
//   const [exitDay, exitMonth, exitYear] = exitDate.split("/");

//   if (entryYear < exitYear) {
//     return true;
//   } else if (entryYear > exitYear) {
//     return false;
//   } else {
//     if (entryMonth < exitMonth) {
//       return true;
//     } else if (entryMonth > exitMonth) {
//       return false;
//     } else {
//       if (entryDay < exitDay) {
//         return true;
//       }
//       return false;
//     }
//   }

//   return false;
// };
const checkDates = (exitDate: string, entryDate: any) => {
  if (!entryDate || !exitDate) return false;

  const isValidDate = (date: string) => moment(date, "DD/MM/YYYY").isValid();
  const [entryDay, entryMonth, entryYear] = entryDate.split("/");
  const [exitDay, exitMonth, exitYear] = exitDate.split("/");

  const isNumeric = (value: any) => !Number.isNaN(Number(value));

  if (
    isNumeric(entryDay) &&
    isNumeric(entryMonth) &&
    isNumeric(entryYear) &&
    isNumeric(exitDay) &&
    isNumeric(exitMonth) &&
    isNumeric(exitYear)
  ) {
    if (isValidDate(entryDate) && isValidDate(exitDate)) {
      return (
        new Date(Number(entryYear), Number(entryMonth) - 1, Number(entryDay)) <
        new Date(Number(exitYear), Number(exitMonth) - 1, Number(exitDay))
      );
    }
  }

  return false;
};

const withNriValidationSchema = (dob: string) =>
  yup.object().shape({
    covidTest: yup.object().shape({
      covidPositive: yup.boolean(),
      covidQuarantine: yup
        .string()
        .when("covidPositive", ([covidPositive], schema) =>
          covidPositive ? schema.required("Required") : schema.notRequired()
        ),
      covidComplication: yup
        .string()
        .when("covidPositive", ([covidPositive], schema) =>
          covidPositive ? schema.required("Required") : schema.notRequired()
        )
    }),
    covidVaccineDates: yup.object().shape({
      covidVaccinated: yup.boolean(),
      dateOfFirstDose: yup.string().when("covidVaccinated", ([covidVaccinated], schema) =>
        covidVaccinated
          ? schema
              // .notRequired()
              // .max(10, "Invalid Date")
              .test("length", "Invalid date", (value) => {
                if (!value) return true;
                if (value && value.length === 10) return true;
                return false;
              })
              .test("is-valid-date", "Invalid date", (value) => {
                if (!value) return true;
                return moment(value, "DD/MM/YYYY").isSameOrBefore(new Date());
              })
              .test("is-valid-date", "Invalid date", (value) => {
                const momentDate = moment(value, "DD/MM/YYYY");
                const isBeforeToday = momentDate.isSameOrBefore(new Date());
                const isAfterJuly = momentDate.isSameOrAfter(moment("01/07/2020", "DD/MM/YYYY"));
                if (!value) return true;
                return isBeforeToday && isAfterJuly;
              })
          : schema.notRequired()
      ),
      dateOfSecondDose: yup
        .string()
        .when(
          ["covidVaccinated", "dateOfFirstDose"],
          ([covidVaccinated, dateOfFirstDose], schema) =>
            covidVaccinated
              ? schema
                  .notRequired()
                  .test("length", "Invalid date", (value) => {
                    if (!value) return true;
                    if (value && value.length === 10 && checkDates(value, dateOfFirstDose))
                      return true;
                    return false;
                  })
                  .test("is-valid-date", "Invalid date", (value) => {
                    if (!value) return true;
                    return moment(value, "DD/MM/YYYY").isValid();
                  })
                  .test("is-valid-date", "Invalid date", (value) => {
                    if (!value) return true;
                    return moment(value, "DD/MM/YYYY").isSameOrBefore(new Date());
                  })
                  .default("")
              : schema.notRequired()
        ),
      dateOfBoosterDose: yup
        .string()
        .when(
          ["covidVaccinated", "dateOfSecondDose", "dateOfFirstDose"],
          ([covidVaccinated, dateOfSecondDose, dateOfFirstDose], schema) =>
            covidVaccinated
              ? schema
                  .notRequired()
                  .test("length", "Invalid date", (value) => {
                    if (!value) return true;
                    if (
                      value &&
                      value.length === 10 &&
                      checkDates(value, dateOfSecondDose) &&
                      checkDates(value, dateOfFirstDose)
                    )
                      return true;
                    return false;
                  })
                  .test("is-valid-date", "Invalid date", (value) => {
                    if (!value) return true;
                    return moment(value, "DD/MM/YYYY").isValid();
                  })
                  .test("is-valid-date", "Invalid date", (value) => {
                    if (!value) return true;
                    return moment(value, "DD/MM/YYYY").isSameOrBefore(new Date());
                  })
                  .default("")
              : schema.notRequired()
        )
    }),
    nriDetails: yup.object().shape({
      currentCountry: yup.string().required("Current Country is Required"),
      cityOfResidence: yup
        .string()
        .required("City Of Residence is Required")
        .matches(regex.fullName, "Enter valid value")
        .max(100, "Max 100 value are allowed"),
      lastDateOfEntryToIn: yup
        .string()
        .required("Last Date is Required")
        .max(10, "Invalid Date")
        .test(
          "invalid-before-birthdate",
          "Invalid Date",
          (value) => !moment(value, "DD/MM/YYYY").isBefore(moment(dob, "DD/MM/YYYY"))
        )
        .test("is-valid-date", "Invalid date", (value) =>
          moment(value, "DD/MM/YYYY").isSameOrBefore(new Date())
        ),
      exitDateFromIndia: yup
        .string()
        .when(["lastDateOfEntryToIn"], ([lastDateOfEntryToIn], schema) =>
          schema
            // .required("Exit Date is Required")
            .test("length", "Invalid date", (value) => {
              if (!value) return true;
              if (value.length === 10 && checkDates(value, lastDateOfEntryToIn)) return true;
              return false;
            })
            .test("is-valid-date", "Invalid date", (value) => {
              if (!value) return true;
              return moment(value, "DD/MM/YYYY").isValid();
            })
            // .test("is-valid-date", "Invalid date", (value) =>
            //   moment(value, "DD/MM/YYYY").isSameOrBefore(new Date())
            // )
            .default("")
        ),
      durationOfStayAbroad: yup
        .string()
        .required("Duration of Stay Abroad is Required")
        .matches(regex.numericNotZero, "Enter valid value")
        .max(3, "Max 3 value are allowed"),
      purposeOfStayAbroad: yup
        .string()
        .required("Purpose of Stay Abroad is Required")
        .matches(regex.specialCharacter, "Enter valid value")
        .max(100, "Max 100 values are allowed"),
      insurancePurpose: yup
        .string()
        .required("Insurance Purpose is Required")
        .matches(regex.specialCharacter, "Enter valid value")
        .max(100, "Max 100 values are allowed")
    }),
    otherCountryTravel: yup.object().shape({
      isOtherCountryTravel: yup.boolean(),
      countryName: yup
        .string()
        .when("isOtherCountryTravel", ([isOtherCountryTravel], schema) =>
          isOtherCountryTravel ? schema.required("Country Name is Required") : schema.notRequired()
        ),
      duration: yup
        .string()
        .when("isOtherCountryTravel", ([isOtherCountryTravel], schema) =>
          isOtherCountryTravel
            ? yup
                .string()
                .required("Duration is Required")
                .matches(regex.numericNotZero, "Enter valid value")
                .max(3, "Max 3 values are allowed")
            : schema.notRequired()
        ),
      purpose: yup
        .string()
        .when("isOtherCountryTravel", ([isOtherCountryTravel], schema) =>
          isOtherCountryTravel
            ? yup
                .string()
                .required("Purpose is Required")
                .matches(regex.specialCharacter, "Enter valid value")
                .max(100, "Max 100 values are allowed")
            : schema.notRequired()
        )
    }),
    occupationDetails: yup.object().shape({
      occupationNameAndRole: yup
        .string()
        .required("Occupation is Required")
        .matches(regex.specialCharacter, "Enter valid value")
        .max(100, "Max 100 values are allowed")
    }),
    salaried: yup.object().shape({
      isSalaried: yup.boolean(),
      companyName: yup
        .string()
        .when("isSalaried", ([isSalaried], schema) =>
          isSalaried
            ? yup
                .string()
                .required("Company Name is Required")
                .matches(regex.alphaNumericWithRestriction, "Enter valid value")
                .max(100, "Max 100 values are allowed")
            : schema.notRequired()
        ),
      designation: yup
        .string()
        .when("isSalaried", ([isSalaried], schema) =>
          isSalaried
            ? yup
                .string()
                .required("Designation is Required")
                .matches(regex.alphaNumericWithRestriction, "Enter valid value")
                .max(100, "Max 100 values are allowed")
            : schema.notRequired()
        ),
      currency: yup
        .string()
        .when("isSalaried", ([isSalaried], schema) =>
          isSalaried
            ? schema.required("Currency is Required").matches(regex.fullName, "Enter valid value")
            : schema.notRequired().matches(regex.fullName, "Enter valid value")
        ),
      monthlyIncome: yup
        .string()
        .when("isSalaried", ([isSalaried], schema) =>
          isSalaried
            ? yup
                .string()
                .required("Monthly Income is Required")
                .matches(regex.numeric, "Enter valid value")
                .max(10, "Max 10 values are allowed")
            : schema.notRequired()
        )
    }),
    selfEmployed: yup.object().shape({
      isSelfEmployed: yup.boolean(),
      grossTurnover: yup
        .string()
        .when("isSelfEmployed", ([isSelfEmployed], schema) =>
          isSelfEmployed
            ? yup
                .string()
                .required("Gross Turnover is Required")
                .matches(regex.numeric, "Enter valid value")
                .max(10, "Max 10 values are allowed")
            : schema.notRequired()
        ),
      annualIncome: yup
        .string()
        .when("isSelfEmployed", ([isSelfEmployed], schema) =>
          isSelfEmployed
            ? yup
                .string()
                .required("Annual Income is Required")
                .matches(regex.numeric, "Enter valid value")
                .max(10, "Max 10 values are allowed")
            : schema.notRequired()
        )
    }),
    bankDetails: yup.object().shape({
      nameOfTheBank: yup
        .string()
        .required("Bank Details are Required")
        .matches(regex.fullName, "Enter valid value")
        .max(100, "Max 100 values are allowed"),
      branch: yup
        .string()
        .required(" Branch is Required")
        .matches(regex.fullName, "Enter valid value")
        .max(100, "Max 100 values are allowed"),
      accountNumber: yup
        .string()
        .required("Account Number is Required")
        .matches(regex.numeric, "Enter valid value")
        .max(20, "Max 20 values are allowed")
    }),
    residence: yup.object().shape({
      nameOfTheBankResidence: yup
        .string()
        .required("Full address is Required")
        .matches(regex.address, "Enter valid value")
        .max(100, "Max 100 values are allowed")
    }),
    policyDetails: yup.object().shape({
      isOtherPolicyOutsideIndia: yup.boolean(),
      insurerName: yup
        .string()
        .when("isOtherPolicyOutsideIndia", ([isOtherPolicyOutsideIndia], schema) =>
          isOtherPolicyOutsideIndia
            ? yup
                .string()
                .required("Insurer Name is Required")
                .matches(regex.fullName, "Enter valid value")
                .max(100, "Max 100 values are allowed")
            : schema.notRequired()
        ),
      sumAssured: yup
        .string()
        .when("isOtherPolicyOutsideIndia", ([isOtherPolicyOutsideIndia], schema) =>
          isOtherPolicyOutsideIndia
            ? yup
                .string()
                .required("Sum Assured is Required")
                .matches(regex.numeric, "Enter valid value")
                .max(20, "Max 20 values are allowed")
            : schema.notRequired()
        ),
      premiumAccount: yup
        .string()
        .when("isOtherPolicyOutsideIndia", ([isOtherPolicyOutsideIndia], schema) =>
          isOtherPolicyOutsideIndia
            ? yup
                .string()
                .required("Premium Amount is Required")
                .matches(regex.numeric, "Enter valid value")
                .max(20, "Max 20 values are allowed")
            : schema.notRequired()
        ),
      policyStatus: yup
        .string()
        .when("isOtherPolicyOutsideIndia", ([isOtherPolicyOutsideIndia], schema) =>
          isOtherPolicyOutsideIndia
            ? yup
                .string()
                .required("Policy Status is Required")
                .matches(regex.fullName, "Enter valid value")
                .max(100, "Max 100 values are allowed")
            : schema.notRequired()
        ),
      dateOfInsurance: yup
        .string()
        .when("isOtherPolicyOutsideIndia", ([isOtherPolicyOutsideIndia], schema) =>
          isOtherPolicyOutsideIndia
            ? yup
                .string()
                .required("Date of Insurance is Required")
                .max(10, "Invalid Date")
                .test(
                  "invalid-before-birthdate",
                  "Invalid Date",
                  (value) => !moment(value, "DD/MM/YYYY").isBefore(moment(dob, "DD/MM/YYYY"))
                )
                .test("is-valid-date", "Invalid date", (value) =>
                  moment(value, "DD/MM/YYYY").isSameOrBefore(new Date())
                )
            : schema.notRequired()
        )
    })
    // addJoint: yup.object().shape({
    //   isJoint: yup.boolean().required("Required")
    // })
  });

const withoutNriValidationSchema = () =>
  yup.object().shape({
    covidTest: yup.object().shape({
      covidPositive: yup.boolean(),
      covidQuarantine: yup
        .string()
        .when("covidPositive", ([covidPositive], schema) =>
          covidPositive ? schema.required("Required") : schema.notRequired()
        ),
      covidComplication: yup
        .string()
        .when("covidPositive", ([covidPositive], schema) =>
          covidPositive ? schema.required("Required") : schema.notRequired()
        )
    }),
    covidVaccineDates: yup.object().shape({
      covidVaccinated: yup.boolean(),
      dateOfFirstDose: yup.string().when("covidVaccinated", ([covidVaccinated], schema) =>
        covidVaccinated
          ? schema
              // .required("First Dose is Required")
              // .max(10, "Invalid Date")
              .test("length", "Invalid date", (value) => {
                if (!value) return true;
                if (value && value.length === 10) return true;
                return false;
              })
              .test("is-valid-date", "Invalid date", (value) => {
                if (!value) return true;
                return moment(value, "DD/MM/YYYY").isSameOrBefore(new Date());
              })
              .test("is-valid-date", "Invalid date", (value) => {
                if (!value) return true;
                const momentDate = moment(value, "DD/MM/YYYY");
                const isBeforeToday = momentDate.isSameOrBefore(new Date());
                const isAfterJuly = momentDate.isSameOrAfter(moment("01/07/2020", "DD/MM/YYYY"));
                return isBeforeToday && isAfterJuly;
              })
          : schema.notRequired()
      ),
      dateOfSecondDose: yup
        .string()
        .when(
          ["covidVaccinated", "dateOfFirstDose"],
          ([covidVaccinated, dateOfFirstDose], schema) =>
            covidVaccinated
              ? schema
                  // .required("Second Dose is Required")
                  .test("length", "Invalid date", (value) => {
                    if (!value) return true;
                    if (value && value.length === 10 && checkDates(value, dateOfFirstDose))
                      return true;
                    return false;
                  })
                  .test("is-valid-date", "Invalid date", (value) => {
                    if (!value) return true;
                    return moment(value, "DD/MM/YYYY").isValid();
                  })
                  .test("is-valid-date", "Invalid date", (value) => {
                    if (!value) return true;
                    return moment(value, "DD/MM/YYYY").isSameOrBefore(new Date());
                  })
                  .default("")
              : schema.notRequired()
        ),
      dateOfBoosterDose: yup
        .string()
        .when(
          ["covidVaccinated", "dateOfSecondDose", "dateOfFirstDose"],
          ([covidVaccinated, dateOfSecondDose, dateOfFirstDose], schema) =>
            covidVaccinated
              ? schema
                  .notRequired()
                  .test("length", "Invalid date", (value) => {
                    if (!value) return true;
                    if (
                      value &&
                      value.length === 10 &&
                      checkDates(value, dateOfSecondDose) &&
                      checkDates(value, dateOfFirstDose)
                    )
                      return true;
                    return false;
                  })
                  .test("is-valid-date", "Invalid date", (value) => {
                    if (!value) return true;
                    return moment(value, "DD/MM/YYYY").isValid();
                  })
                  .test("is-valid-date", "Invalid date", (value) => {
                    if (!value) return true;
                    return moment(value, "DD/MM/YYYY").isSameOrBefore(new Date());
                  })
                  .default("")
              : schema.notRequired()
        )
    })
  });

export { withNriValidationSchema, withoutNriValidationSchema };
